export {
  default as loader
} from './src/loader';

export {
  default as read
} from './src/read';

export {
  inferType,
  inferTypes,
  typeParsers
} from './src/type';

export {
  default as formats
} from './src/formats/index';



// WEBPACK FOOTER //
// ./~/vega-loader/index.js